import { useTranslation } from "react-i18next";

export interface TallyProps {
  total: number;
  present: number;
  absent: number;
  unmarked: number;
}

function Cell({ label, value, tone }: { label: string; value: number; tone: string }) {
  return (
    <div className="rounded-lg bg-app-field p-2 text-center">
      <span className={`block text-[11px] font-semibold uppercase ${tone}`}>{label}</span>
      <span className={`text-2xl font-bold ${tone}`}>{value}</span>
    </div>
  );
}

export function AttendanceTally({ total, present, absent, unmarked }: TallyProps) {
  const { t } = useTranslation();
  // The rate is of those actually marked present, against the full roster —
  // unmarked teachers count against it, which is the point of the bar.
  const rate = total === 0 ? 0 : (present / total) * 100;

  return (
    <section className="rounded-xl bg-surface p-4 shadow-raised">
      <div className="mb-3 flex items-center justify-between">
        <span className="text-sm text-app-muted">{t("rollCallMetric")}</span>
        <span className="rounded-full bg-accent-soft px-2 py-0.5 text-xs font-semibold text-accent">
          {t("attendanceRate", { rate: rate.toFixed(1) })}
        </span>
      </div>
      <div className="grid grid-cols-4 gap-2">
        <Cell label={t("total")} value={total} tone="text-app-ink" />
        <Cell label={t("present")} value={present} tone="text-success-text" />
        <Cell label={t("absent")} value={absent} tone="text-accent-strong" />
        <Cell label={t("unmarked")} value={unmarked} tone="text-app-muted" />
      </div>
      <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-app-field">
        <div
          className="h-full rounded-full bg-success transition-all duration-300"
          style={{ width: `${rate}%` }}
        />
      </div>
    </section>
  );
}
